export default "__VITE_ASSET__BuyqR5ud__"